import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LuEllipsisVertical, LuHouse, LuRepeat, LuWallet, LuDownload, LuUsers, LuBadgeDollarSign } from 'react-icons/lu';

export default function MobileBottomBar({ ib }) {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const getFirstPath = (path) => {
        const parts = path.split('/');
        if (ib) {
            return parts.length > 1 ? '/' + parts[1] + '/' + parts[2] : path;
        }
        return parts.length > 1 ? '/' + parts[1] : path;
    };

    const isActivePath = (activeUrls) => {
        return activeUrls.some((url) => url === getFirstPath(pathname));
    };

    const userNavItems = [
        {
            title: 'Home',
            icon: <LuHouse size={20} />,
            url: '/dashboard',
            activeUrl: ['/dashboard', '/account'],
        },
        {
            title: 'Deposit Withdraw',
            icon: <LuWallet size={20} />,
            url: '/wallet',
            activeUrl: ['/wallet', '/deposit', '/withdraw', '/deposit_usdt'],
            activeColor: '#193CB8',
        },
        {
            title: 'Internal Transfer',
            icon: <LuRepeat size={20} />,
            url: '/transfer',
            activeUrl: ['/transfer'],
            activeColor: '#193CB8',
        },
        {
            title: 'App Download',
            icon: <LuDownload size={20} />,
            url: '/download',
            activeUrl: ['/download'],
            activeColor: '#193CB8',
        },
        {
            title: 'More',
            icon: <LuEllipsisVertical size={20} />,
            url: '/settings',
            activeUrl: ['/settings', '/accounts', '/trades', '/support', '/profile', '/change_password', '/leaderboard', '/tutorials', '/faq', '/kyc', '/my_transaction', '/inbox'],
            activeColor: '#193CB8',
        },
    ];

    const ibNavItems = [
        {
            title: 'Home',
            icon: <LuHouse size={20} />,
            url: '/ib/dashboard',
            activeUrl: ['/ib/dashboard'],
            activeColor: '#193CB8',
        },
        {
            title: 'IB Wallet',
            icon: <LuWallet size={20} />,
            url: '/ib/withdraw',
            activeUrl: ['/ib/withdraw'],
            activeColor: '#193CB8',
        },
        {
            title: 'My Team',
            icon: <LuUsers size={20} />,
            url: '/ib/my_trader_team',
            activeUrl: ['/ib/my_trader_team'],
            activeColor: '#193CB8',
        },
        {
            title: 'Commission',
            icon: <LuBadgeDollarSign size={20} />,
            url: '/ib/commission',
            activeUrl: ['/ib/commission', '/ib/commission_distribute'],
            activeColor: '#193CB8',
        },
        {
            title: 'More',
            icon: <LuEllipsisVertical size={20} />,
            url: '/ib/settings',
            activeUrl: ['/ib/settings', '/ib/kyc_manager', '/ib/ib_manager', '/ib/tree', '/ib/live_account', '/ib/promotion', '/ib/support', '/ib/inbox'],
            activeColor: '#193CB8',
        },
    ];

    const bottomNavItems = ib ? ibNavItems : userNavItems;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100 shadow-lg lg:hidden">
            <div className="flex justify-around items-center max-w-full mx-auto px-2 py-2">
                {bottomNavItems.map((item, index) => {
                    const isActive = isActivePath(item.activeUrl);
                    const iconWithProps = React.isValidElement(item.icon) && item.icon.type !== 'svg'
                        ? React.cloneElement(item.icon, { active: isActive, activeColor: item.activeColor })
                        : item.icon;

                    return (
                        <div
                            key={index}
                            className="flex flex-col items-center justify-center py-2 px-1 cursor-pointer transition-all duration-200 rounded-xl min-w-[60px] flex-1 max-w-[80px] hover:bg-blue-50 text-gray-600"
                            style={isActive ? { color: item.activeColor } : {}}
                            onClick={() => navigate(item.url, { state: { title: item.title } })}
                        >
                            <div className="mb-1 flex items-center justify-center w-8 h-8">
                                <div
                                    className={`transition-colors duration-200 ${isActive ? 'primary' : 'text-gray-500'}`}
                                    style={isActive ? { color: item.activeColor } : {}}
                                >
                                    {iconWithProps}
                                </div>
                            </div>
                            <span className={`text-[11px] font-medium text-center leading-tight transition-colors duration-200 max-w-full ${isActive ? 'primary' : 'text-gray-600'}`}>
                                {item.title}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
